
import {getCurrentList, fetchTimeZoneList} from '@/api/generalapi.js'
export const GeneralMixins = {
  data () {
    return {
      currencyLists:[],
      platformTimeZone:[]
    }
  },
  methods:{
    async fetchCurrencyList () {
      try {
        const responseCurrency = await getCurrentList()
        this.currencyLists = responseCurrency.data.data.currency_list 
                
      } catch (error) {
        console.warn(error)
      }
    },
    async fetchPLatformTimeZone () {
      try {
        const responsePlatform = await fetchTimeZoneList()
        this.platformTimeZone = responsePlatform.data.data.list
        // 
                    
      } catch (error) {
        console.warn(error)
      }
        
    }
  }

}